<template>
  <div id="shuhoShokai">
    <el-row id="selectButtons">
      <el-col :span="8">
        <span id="torokuBiLabel">週開始日：</span>
        <el-button type="default" @click="onChange(-7)" size="medium" icon="el-icon-arrow-left">前週</el-button>
        <el-date-picker v-model="form.torokuBi" @change="onChange" id="torokuBi" value-format="yyyy-MM-dd" :editable="false" :clearable="false" :picker-options="pickerOptions" size="medium"></el-date-picker>
        <el-button type="default" @click="onChange(7)" size="medium">翌週 <i class="el-icon-arrow-right" /></el-button>
      </el-col>
      <el-col :span="4" id="selecterCol">
        <span id="selecterLabel">提出者のみ表示：</span>
        <el-switch id="selecterSwitch" v-model="showOnlySelected">
        </el-switch>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" :model="form" :rules="rules" label-width="0px" v-loading="loading" size="medium">
          <el-form-item label="フィルター：" prop="filterWord" label-width="105px" >
            <el-input id="filter" v-model="form.filterWord" size="medium" placeholder="社員、部署、取引先、現場名で絞り込み。"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" align="center">
        <el-button type="primary" @click="onIkkatsuDownload" size="medium">Excel一括出力</el-button>
      </el-col>
    </el-row>
    <el-table id="jokyoShokaiTable" ref="jokyoShokaiTable" :data="filteredShainList"
        :default-sort="{prop: 'shainBango', order: 'ascending'}" :height="tableHeight" @select="selectTable" v-loading="loading" stripe border>
      <el-table-column type="selection" width="40" align="center"></el-table-column>
      <el-table-column type="index" label="No." width="45" align="right"></el-table-column>
      <el-table-column label="参照" width="57">
        <template slot-scope="scope">
          <el-button icon="el-icon-view" size="mini" @click="getShuho(scope.row.shainId)"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="shainShimei" label="社員氏名" width="125" sortable></el-table-column>
      <el-table-column prop="jokyoKubunMei" label="状況" width="95" sortable></el-table-column>
      <el-table-column label="上長ｺﾒﾝﾄ" width="70">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.jochoComment" effect="light" placement="bottom-start">
            <div slot="content" class="comment-tooltip">{{scope.row.jochoComment}}</div>
            <el-link type="success">有</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="bushoMei" label="部署名" width="247" sortable></el-table-column>
      <el-table-column prop="torihikisakiMei" label="取引先名" width="180" sortable></el-table-column>
      <el-table-column prop="genbaMei" label="現場名" width="180" sortable></el-table-column>
      <el-table-column prop="zangyoJikan" label="残業時間" width="90" sortable sort-by="zangyoHours" align="right"></el-table-column>
      <el-table-column prop="biko" label="備考" width="95" sortable></el-table-column>
      <el-table-column prop="shainBango" label="社員番号" width="85" sortable></el-table-column>
    </el-table>
    <el-dialog id="shujiCard" :title="form.shuho.shainShimei + '（' + form.shuho.kikan + '）'" :modal="false" :visible.sync="isDialogVisible" width="1050px" top="80px">
      <el-form ref="form" :model="form.shuho" :rules="rules" label-width="0px" v-loading="loading" size="medium">
        <div id="shuhoScroll">
          <el-row>
            <el-col :span="12">
              <el-form-item label="スタッフ名" prop="shainShimei" label-width="85px">
                <span id="shainShimei">{{form.shuho.shainShimei}}</span>
                <span id="shuhoJokyoKubunMeiSpan">{{form.shuho.shuhoJokyoKubun == '21' ? '提出済' : form.shuho.shuhoJokyoKubun == '31' ? '上長確認済' : ''}}</span>
                <span id="shuhoJokyoKubunSpan">状況</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部署名" prop="bushoMei" id="bushoMei" label-width="85px">
                <el-input v-model="form.shuho.bushoMei" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="取引先名" prop="torihikisakiMei" id="torihikisakiMei" label-width="85px">
                <el-input v-model="form.shuho.torihikisakiMei" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="現場名" prop="genbaMei" id="genbaMei" label-width="85px">
                <el-input v-model="form.shuho.genbaMei" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="期間" prop="kikan" id="kikan" label-width="85px">
                <span id="kikanLabel">{{form.shuho.kikan}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="残業時間" prop="zangyo" id="zangyo" label-width="85px">
                <span id="zangyoLabel">{{form.shuho.zangyoJikan}}</span><span id="minyuryokuAlert" v-if="form.shuho.minyuryokubiFlag">※勤務実績未入力日があります。</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="subtitleBar">
            <el-tag effect="dark">個人の状況（報告・連絡・相談）</el-tag>
          </el-form-item>
          <el-form-item label="体調" prop="taicho" label-width="85px">
            <el-slider v-model="form.shuho.taicho" disabled :step="1" :min="0" :max="10" :marks="marksTaicho" show-stops></el-slider>
          </el-form-item>
          <el-form-item label="負荷" prop="fuka" label-width="85px">
            <el-slider v-model="form.shuho.fuka" disabled :step="1" :min="0" :max="10" :marks="marksFuka" show-stops></el-slider>
          </el-form-item>
          <el-form-item label="現場満足度" prop="genbaManzokudo" label-width="85px">
            <el-slider v-model="form.shuho.genbaManzokudo" disabled :step="1" :min="0" :max="10" :marks="marksGenbaManzokudo" show-stops></el-slider>
          </el-form-item>
          <el-form-item><!-- 改行用 --></el-form-item>
          <el-form-item class="subtitleBar">
            <el-tag effect="dark">スケジュール</el-tag>
          </el-form-item>
          <el-form-item prop="thisWeekTask">
            <span class="textarea-label">今週タスク</span>
            <el-input v-model="form.shuho.thisWeekTask" disabled :autosize="{ minRows: 1}" type="textarea"></el-input>
          </el-form-item>
          <el-form-item prop="nextWeekTask">
            <span class="textarea-label">来週予定タスク</span>
            <el-input v-model="form.shuho.nextWeekTask" disabled :autosize="{ minRows: 1}" type="textarea"></el-input>
          </el-form-item>
          <el-form-item prop="problems">
            <span class="textarea-label">課題・困りごと</span>
            <el-input v-model="form.shuho.problems" disabled :autosize="{ minRows: 1}" type="textarea"></el-input>
          </el-form-item>
          <el-form-item prop="irregularWork" id="irregularWork">
            <span class="textarea-label">変則勤務・勤怠変更等</span>
            <el-input v-model="form.shuho.irregularWork" disabled :autosize="{ minRows: 1}" type="textarea"></el-input>
          </el-form-item>
          <el-form-item class="subtitleBar">
            <el-tag effect="dark">現場・その他の状況（報告・連絡・相談）</el-tag>
          </el-form-item>
          <el-form-item prop="sonotaJokyo">
            <span class="textarea-label">その他連絡</span>
            <el-input v-model="form.shuho.sonotaJokyo" disabled :autosize="{ minRows: 1}" type="textarea"></el-input>
          </el-form-item>
          <div class="bottom-items">
            <el-button v-if="canJochoKakunin()" type="success" @click="onComment">確認・コメント</el-button>
            <el-button type="primary" @click="onDownload">Excel出力</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog id="commentDialog" title="確認・コメント" :visible.sync="isCommentDialogVisible" width="600px" top="60px">
      <div>
        <h3>この週報を「上長確認済」にします。</h3>
        <h4>提出者へのコメントがある場合は以下に記入してください。（任意）</h4>
        <h4>コメントを記入した場合は、提出者にメールで通知します。</h4>
        <el-input type="textarea" rows="13" maxlength="500" show-word-limit v-model="form.shuho.jochoComment"></el-input>
        <el-button type="primary" @click="onJochoKakunin" size="medium">OK</el-button>
        <el-button type="danger" @click="closeCommentDialog" size="medium">Cancel</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyWarning, notifyError, downloadFile } from '../utils.js'

export default {
  name: 'ShuhoShokai',
  data() {
    return {
      form: {
        torokuBi: '',
        shainList: [],
        shainId: '',
        shainBango: '',
        shainShimei: '',
        kengenKubun: '',
        jochoShainId: '',
        jochoShainId2: '',
        jochoShainId3: '',
        shuho: {jochoComment: ''},
        filterWord: '',
      },
      isDialogVisible: false,
      isCommentDialogVisible: false,
      showOnlySelected: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getDay() != 1;
        }
      },
      marksTaicho: {
        0: '悪い',
        5: '普通',
        10: '良い',
      },
      marksFuka: {
        0: '低い',
        5: '普通',
        10: '高い',
      },
      marksGenbaManzokudo: {
        0: '低い',
        5: '普通',
        10: '高い',
      },
      rules: {
      },
      tableHeight: 0,
      scrollHeight: 0,
      targetRow: null,
      jokyoSelect: null,
      checkSelect: null,
      loading: true
    }
  },
  computed: {
    filteredShainList() {
      const word = this.form.filterWord;
      
      return this.form.shainList.filter(data => (!word || data.shainShimei?.includes(word) || data.bushoMei?.includes(word)
         || data.torihikisakiMei?.includes(word) || data.genbaMei?.includes(word)) && (!this.showOnlySelected || data.torokuBi));
    },
  },
  created() {
    if (this.$route.params.torokuBi === undefined) {
      this.form.torokuBi = this.$parent.getTorokuBi();
    } else {
      this.form.torokuBi = this.$route.params.torokuBi;
    }
    this.getData();
  },
  mounted () {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.tableHeight = window.innerHeight - 160;
      this.tableHeight = document.documentElement.clientHeight - 160;
    },
    canJochoKakunin() {
      let loginUserId = this.$parent.getShainId();
      let shuhoUserId = this.form.shuho.shainId;
      return loginUserId != shuhoUserId;
    },
    getData() {
      this.$parent.setTorokuBi(this.form.torokuBi);
      this.loading = true;
      this.$axios.get('/gwr/shuho/shuhoIchiran/' + this.form.torokuBi)
          .then((response) => {
            this.form.shainList = response.data.map(value => {
              return {
                ...value,
                biko: value.minyuryokubiFlag ? '勤務実績未入力日あり' : '',
                jokyoKubunMei: value.shuhoJokyoKubun == '21' ? '提出済' : value.shuhoJokyoKubun == '31' ? '上長確認済' : '',
                jochoComment: value.jochoComment == 'null' ? '' : value.jochoComment
              }
            });
            this.loading = false;
            this.handleResize();
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    getShuho(shainId) {
      this.loading = true;
      this.$parent.setTorokuBi(this.form.torokuBi);
      let url = '/gwr/shuho/shujiHokoku/' + this.form.torokuBi + '/' + shainId;
      this.$axios.get(url)
          .then((response) => {
            this.form.shuho.shainId = response.data.shainId;
            this.form.shuho.shainShimei = response.data.shainShimei;
            this.form.shuho.bushoMei = response.data.bushoMei;
            this.form.shuho.torihikisakiMei = response.data.torihikisakiMei;
            this.form.shuho.genbaMei = response.data.genbaMei;
            this.form.shuho.kikan = response.data.kikan;
            this.form.shuho.zangyoJikan = response.data.zangyoJikan;
            this.form.shuho.taicho = response.data.taicho;
            this.form.shuho.fuka = response.data.fuka;
            this.form.shuho.genbaManzokudo = response.data.genbaManzokudo;
            this.form.shuho.thisWeekTask = response.data.thisWeekTask;
            this.form.shuho.nextWeekTask = response.data.nextWeekTask;
            this.form.shuho.problems = response.data.problems;
            this.form.shuho.irregularWork = response.data.irregularWork;
            this.form.shuho.sonotaJokyo = response.data.sonotaJokyo;
            this.form.shuho.shuhoJokyoKubun = response.data.shuhoJokyoKubun;
            this.form.shuho.minyuryokubiFlag = response.data.minyuryokubiFlag;
            this.form.shuho.jochoComment = response.data.jochoComment == 'null' ? '' : response.data.jochoComment;
            this.form.shuho.shain = response.data.shain;
            this.isDialogVisible = true;
            this.loading = false;
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    doFilter(row) {
      if (this.showOnlySelected) {
        return row.torokuBi;
      } else {
        return true;
      }
    },
    selectTable() {
      this.jokyoSelect = null;
      this.checkSelect = null;
    },
    onChange(offset) {
      this.loading = true;
      if (!this.form.torokuBi) {
        // 表示日がブランクの場合、後続処理は実行しない。
        this.loading = false;
        return;
      }
      if (offset !== undefined) {
        this.form.torokuBi = this.$moment(this.form.torokuBi).add(offset, 'days').format('YYYY-MM-DD');
      }
      this.getData();
    },
    onComment() {
      this.isCommentDialogVisible = true;
    },
    closeCommentDialog() {
      this.isCommentDialogVisible = false;
    },
    onJochoKakunin() {
      this.loading = true;
      let params = {
        shainId: this.form.shuho.shainId,
        torokuBi: this.form.torokuBi,
        jochoComment: this.form.shuho.jochoComment != null ? this.form.shuho.jochoComment : '',
      }
      params = new URLSearchParams(params);
      this.$axios.post('/gwr/shuho/shuhoJochoKakunin', params)
          .then((response) => {
            this.getData();
            this.isCommentDialogVisible = false;
            this.isDialogVisible = false;
            if (response.status == '200') {
              notifySuccess(this, '処理完了', '確認済に変更しました。');
            } else {
              notifyWarning(this, '処理完了', '確認済に変更しましたがメール送信に失敗しました。別途連絡をお願いします。');
            }
          })
          .catch((error) => {
            notifyError(this, error, 'データ登録エラー');
          });
      this.isCheckDialogVisible = false;
    },
    onDownload() {
      this.loading = true;
      this.$axios.get('/gwr/shuho/downloadShuho/' + this.form.torokuBi + '/' + this.form.shuho.shainId, { responseType: 'blob' })
        .then((response) => {
          downloadFile(this, response);
        })
        .catch((error) => {
          notifyError(this, error, 'ダウンロードエラー');
        });
    },
    onIkkatsuDownload() {
      this.loading = true;
      let shainIdList = [];
      this.$refs.jokyoShokaiTable.selection.forEach(shain => {
        shainIdList.push(shain.shainId);
      });
      if (shainIdList.length == 0) {
        notifyWarning(this, '選択', '出力対象の社員を選択してください。');
        return;
      }

      let params = new URLSearchParams();
      params.append('torokuBi', this.form.torokuBi);
      params.append('shainIdList', shainIdList);

      this.$axios.post('/gwr/shuho/shuhoIkkatsuDownload', params, { responseType: 'blob' })
        .then((response) => {
          downloadFile(this, response);
          this.getData();
        })
        .catch((error) => {
          notifyError(this, error, 'ダウンロードエラー');
        });
    },
  },
}
</script>

<style scoped>
.shuhoShokai {
  width: 1310px;
  margin-left: auto;
  margin-right: auto;
  line-height: 35px;
}
#torokuBiLabel {
  font-size: 14px;
  margin-right: 10px;
}
#selecterLabel {
  font-size: 14px;
  margin-right: 10px;
}
#selecterCol {
  line-height: 36px;
}
#selectButtons {
  width: 1310px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
#jokyoShokaiTable {
  width: 1310px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> th {
  padding: 0px 0px;
  background-color: whitesmoke;
  border-color: lightgray;
  color: dimgray;
}
#jokyoShokaiTable >>> th div {
  padding: 0px 0px;
  text-align: center;
}
#jokyoShokaiTable >>> td {
  padding: 0px 0px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> .el-button--mini {
  padding: 6px 10px;
}
.el-input.is-disabled >>> .el-input__inner {
  color: black !important;
}
.el-textarea.is-disabled >>> .el-textarea__inner {
  color: black !important;
}
#shujiCard >>> .el-slider__bar {
  background-color: teal !important;
}
.el-button {
  margin: 0px 1px !important;
}
.el-date-editor {
  width: 135px !important;
}
.textarea-label {
  float: left;
}
#shujiCard {
  margin-left: 220px;
}
#shujiCard >>> .el-dialog__header {
  text-align: left;
  background-color: #6161b0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
#shujiCard >>> .el-dialog__title {
  color: white;
}
#shujiCard >>> .el-form-item {
  text-align: left;
}
#shujiCard >>> .el-tag {
  width: 950px;
}
#shujiCard >>> .el-slider {
  width: 700px;
}
#shujiCard >>> .el-slider__marks-text {
  width: 50px;
  text-align: center;
}
#shujiCard >>> .el-input__inner {
  width: 375px;
}
#shujiCard >>> .el-textarea__inner {
  width: 950px;
}
#shuhoShokai >>> .el-dialog {
  background-color: #f5f7fa;
}
#selectButtons >>> .el-form-item {
  margin-bottom: 0px;
}
#minyuryokuAlert {
  color: red;
  margin-left: 10px;
}
#shuhoScroll {
  height: calc(100vh - 250px);
  width: 1000px;
  overflow-y: scroll;
}
#commentDialog >>> .el-textarea {
  margin-bottom: 10px;
}
#shuhoJokyoKubunSpan {
  float: right;
  margin-right: 16px;
}
#shuhoJokyoKubunMeiSpan {
  float: right;
  margin-right: 40px;
}
h3 {
  margin: 0px;
}
h4 {
  font-weight: normal;
  margin: 0px;
}
.comment-tooltip {
  white-space: pre;
  font-size: 14px;
}
</style>
